import React, { useEffect, useState } from 'react';

import AnonymousNavbar from '../components/navbars/AnonymousNavbar';
import Footer from './components/footer';

import { navbarTheme, footerTheme } from '../utility/constants/themeConfig';
import { useQuery } from '../hooks/useQuery';

const AnonymousLayout = ({ children, ...rest }) => {
    const query = useQuery();
    const sourceId = query.get('sourceId') || query.get('viewSourceId');
    const [navbarConfig, setNavbarConfig] = useState(null);
    const [footerConfig, setFooterConfig] = useState(null);
    useEffect(() => {
        setNavbarConfig({
            ...rest,
            ...(navbarTheme[sourceId] || navbarTheme['default']),
        });
    }, [sourceId]);

    useEffect(() => {
        setFooterConfig({
            ...{ footerType: rest.footerType },
            ...(footerTheme[rest?.footerType || sourceId] ||
                footerTheme['default']),
        });
    }, [sourceId, rest.footerType]);

    return (
        <div className="anonymous-layout">
            {rest.showNavbar ? <AnonymousNavbar {...navbarConfig} /> : null}
            {children}
            {rest.showFooter ? <Footer {...footerConfig} /> : null}
        </div>
    );
};

export default AnonymousLayout;
